import { render, staticRenderFns } from "./DistributeItem.vue?vue&type=template&id=95a36a44&scoped=true&"
import script from "./DistributeItem.vue?vue&type=script&lang=js&"
export * from "./DistributeItem.vue?vue&type=script&lang=js&"
import style0 from "./DistributeItem.vue?vue&type=style&index=0&id=95a36a44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a36a44",
  null
  
)

export default component.exports